import { Fragment, type ReactNode } from 'react'

/**
 * Renders a translated body whose `{name}` placeholders stand for React nodes
 * rather than strings. `useLabel` returns a string, so a body with an inline
 * link cannot come from the dictionary without this.
 *
 * Splitting on the placeholder rather than stitching English fragments together
 * leaves word order with the translator — German and Finnish do not put the
 * link where English does.
 */
export function withNodes(
  template: string,
  nodes: Record<string, ReactNode>,
): ReactNode[] {
  return template.split(/(\{\w+\})/g).map((part, index) => {
    const name = /^\{(\w+)\}$/.exec(part)?.[1]
    if (name === undefined) return part

    return <Fragment key={`${name}-${index}`}>{nodes[name] ?? part}</Fragment>
  })
}
